module.exports = __webpack_public_path__ + "static/img/version6.e48e9c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/version6.png
// module id = sV2J
// module chunks = 1